import React from "react";
import { Outlet } from "react-router-dom";
import { Navbar } from "./Navbar";
import { Footer } from "./Footer";
import { AnnouncementBar } from "./AnnouncementBar";

export const PublicLayout = () => (
  <div className="min-h-screen flex flex-col bg-[#0B0F17]">
    <AnnouncementBar />
    <Navbar />
    <main className="flex-1"><Outlet /></main>
    <Footer />
  </div>
);
